var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2_00000096757133733668803010000002214025846011605950_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 513.5 300.8",
    style: {
      enableBackground: "new 0 0 513.5 300.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FF6600;stroke-width:26;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "money_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 15.8,
    className: "st0",
    width: 406.1,
    height: 204.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "440.6,66.9 478.2,66.9 478.2,270.9 72.2,270.9 72.2,219.9  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 90.5,
    y1: 117.9,
    x2: 151.8,
    y2: 117.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 324.7,
    y1: 117.9,
    x2: 386,
    y2: 117.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.3,161.6h46.2c15.3,0,27.7-9.8,27.7-21.8l0,0c0-12.1-12.4-21.8-27.7-21.8h-19.3 c-15.3,0-27.7-9.8-27.7-21.8l0,0c0-12.1,12.4-21.8,27.7-21.8h46.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 238.3,
    y1: 50.7,
    x2: 238.3,
    y2: 65.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 238.3,
    y1: 168.9,
    x2: 238.3,
    y2: 183.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.53251e43328996494566812dd780739f.svg";
export { ForwardRef as ReactComponent };